import crmlist from '@/views/crmlist'

export default {
  path: '/crmlist',
  component: crmlist,
  name: 'crmlist',
  meta: {
    title: '会员'
  },
  children: [
    {
      path: 'Crmlist',
      component: () => import('@/views/crmlist/Crmlist'),
      name: '',
      meta: {
        title: '会员列表'
      }
    }

  ]
}
